import { Button, Flex } from 'antd'
import { t } from 'i18next'
import _ from 'lodash'
import React from 'react'
import AvailableNowCard from '../AvailableNowCard'
import PublicSiderXS from '../../Layouts/Sider/PublicSiderXS'

export default function MobileBoxSlotList ({ box, daysList, more }) {
  return (
    <>
      <PublicSiderXS />
      <Flex vertical align='center' style={{ margin: '0 1em' }}>
        {
          box && box['available_now?'] &&
          <div style={{ margin: '0 8%' }}>
            <AvailableNowCard box={box} />
          </div>
        }
        {daysList}
        <Button style={{ margin: '2em 23% 1em 22%' }} onClick={more} type="primary">{t('Public.BoxPage.more')}</Button>
      </Flex>
    </>
  )
}
